<template>
  <div class="app">
    <div class="header01" v-if="!isMobile">
      <el-menu :default-active="String(activeIndex)" class="el-menu-vertical-demo" @open="handleOpen"
        @close="handleClose">
        <el-menu-item index="1" @click="goToPersonalInf">
          <i class="el-icon-reading"></i>
          <span slot="title">学业信息</span>
        </el-menu-item>
        <el-menu-item index="2" @click="goToCareertest">
          <i class="el-icon-suitcase"></i>
          <span slot="title">职业测试</span>
        </el-menu-item>
        <el-menu-item index="3" @click="goToResearchrep">
          <i class="el-icon-document"></i>
          <span slot="title">测试报告</span>
        </el-menu-item>
        <el-menu-item index="8" @click="goToRecommend">
          <i class="el-icon-position"></i>
          <span slot="title">就业方向</span>
        </el-menu-item>
        <el-menu-item index="4" @click="goTozhiyefangxiang">
          <i class="el-icon-pie-chart"></i>
          <span slot="title">职业方向规划</span>
        </el-menu-item>
        <el-menu-item index="5" @click="goToqiyeJob">
          <i class="el-icon-place"></i>
          <span slot="title">推荐岗位</span>
        </el-menu-item>
        <el-menu-item index="6" @click="goToUserInfo">
          <i class="el-icon-user"></i>
          <span slot="title">个人信息</span>
        </el-menu-item>
        <el-menu-item index="7" @click="goToUserSystem">
          <i class="el-icon-setting"></i>
          <span slot="title">系统设置</span>
        </el-menu-item>
      </el-menu>
    </div>

    <div class="header01" v-else>
      <el-menu :default-active="String(activeIndex)" class="el-menu-vertical-demo" mode="horizontal"
        @select="handleSelect">
        <el-menu-item index="1" @click="goToPersonalInf">学业信息</el-menu-item>
        <el-menu-item index="2" @click="goToCareertest">职业测试</el-menu-item>
        <el-menu-item index="3" @click="goToResearchrep">测试报告</el-menu-item>
        <el-menu-item index="8" @click="goToRecommend">就业方向</el-menu-item>
        <el-menu-item index="4" @click="goTozhiyefangxiang">职业方向规划</el-menu-item>
        <el-menu-item index="5" @click="goToqiyeJob">推荐岗位</el-menu-item>
        <el-menu-item index="6" @click="goToUserInfo">个人信息</el-menu-item>
        <el-menu-item index="7" @click="goToUserSystem">系统设置</el-menu-item>
      </el-menu>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    activeIndex: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      isMobile: false
    }
  },
  name: 'Header',
  mounted() {
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  methods: {
    handleSelect(key, keyPath) {
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    goToqiyeJob() {
      if (this.$route.path !== '/qiyeJob') {
        this.$router.push('/qiyeJob');
      }
    },
    goTozhiyefangxiang() {
      if (this.$route.path !== '/zhiyefangxiang') {
        this.$router.push('/zhiyefangxiang');
      }
    },
    goToCareertest() {
      if (this.$route.path !== '/CareerQuiz') {
        this.$router.push('/CareerQuiz');
      }
    },
    goToUserSystem() {
      if (this.$route.path !== '/usersystem') {
        this.$router.push('/usersystem');
      }
    },
    goToRecommend() {
      if (this.$route.path !== '/recommend') {
        this.$router.push('/recommend');
      }
    },
    goToUserInfo() {
      if (this.$route.path !== '/userInfo') {
        this.$router.push('/userInfo');
      }
    },
    goToPersonalInf() {
      if (this.$route.path !== '/personalInf') {
        this.$router.push('/personalInf');
      }
    },
    goToResearchrep() {
      if (this.$route.path !== '/researchrep') {
        this.$router.push('/researchrep');
      }
    },
    handleOpen(key, keyPath) {
      console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      console.log(key, keyPath);
    },
  }
}
</script>

<style scoped>
.header01 {
  width: 220px;
}

.el-menu-vertical-demo {
  text-align: left;
  margin-left: 20px;
  height: 87vh;
}

@media (max-width: 768px) {
  .header01 {
    width: 100%;
  }

  .el-menu-vertical-demo {
    margin-left: 0;
    height: auto;
    padding: 10px 0;
  }

  .el-menu-item {
    font-size: 14px;
  }

  .el-menu--horizontal>.el-menu-item {
    height: 35px !important;
    line-height: 35px !important;
  }

  .el-dropdown-menu__item,
  .el-menu-item {
    font-size: 14px;
    padding: 0px 5px !important;
    cursor: pointer;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue